import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Result, Spin } from "antd";
import { Form, Input, Button, Row, Col, message } from "antd";
import {
  LockOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import axios from "axios";

const ResetPassword = () => {
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const getResetPasswordToken = () => {
    // const params = new URLSearchParams(location.search);
    return searchParams.get("token");
  };

  const onFinish = async (values) => {
    const token = getResetPasswordToken();
    if (!token) {
      message.error("Invalid reset password token");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post("/api/accounts/update_password/", {
        token: token,
        password1: values.password,
        password2: values.confirm,
      });

      if (response.status === 200) {
        message.success("Reset password successfully!");
        form.resetFields();
        navigate("/login", { replace: true });
      }
    } catch (error) {
      if (error.response) {
        // DRF returns { detail: ... } / { token: [...] } / { password1: [...] }
        // / "raw text" / etc. Build the most useful message we can.
        const data = error.response.data;
        let detail = "";
        if (typeof data === "string" && data) {
          detail = data;
        } else if (data && typeof data === "object") {
          detail =
            data.detail ||
            data.message ||
            (Array.isArray(data.non_field_errors)
              ? data.non_field_errors.join(" ")
              : "") ||
            Object.entries(data)
              .map(
                ([k, v]) => `${k}: ${Array.isArray(v) ? v.join(", ") : v}`
              )
              .join("; ");
        }
        message.error(
          `Reset password failed${detail ? ": " + detail : ""}`
        );
      } else {
        message.error(
          error?.message
            ? `Network error: ${error.message}`
            : "Network error, please try again!"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row justify="center" style={{ marginTop: 100 }}>
      <Col xs={24} sm={12} md={8} lg={6}>
        <div style={{ padding: 24, background: "#fff", borderRadius: 4 }}>
          <h2 style={{ textAlign: "center", marginBottom: 24 }}>
            Reset Password Request
          </h2>
          <Form
            form={form}
            name="reset_password"
            onFinish={onFinish}
            scrollToFirstError
            layout="vertical"
          >
            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
                {
                  min: 8,
                  message: "Password must be at least 8 characters",
                },
              ]}
              hasFeedback
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Enter Password"
                autoComplete="new-password"
              />
            </Form.Item>

            <Form.Item
              label="Confirm Password"
              name="confirm"
              dependencies={["password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please confirm your password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "The two passwords that you entered do not match!"
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Confirm Password"
                autoComplete="new-password"
              />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" block loading={loading}>
                Reset Password
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Col>
    </Row>
  );
};

export default ResetPassword;
